import { RequestOptions } from 'careand-redux/api/ApiThunks';
import { z } from 'zod';
import { createMessage, NativeMessageSchema } from './NativeMessage';
import { URLRequest, URLRequestSchema } from './URLRequest';

export const ShareMessageSchema = z
  .object({
    type: z.literal('Share'),
    content: z.object({
      text: z.string().optional(),
    }),
  })
  .extend(NativeMessageSchema.shape);

export type ShareMessage = z.infer<typeof ShareMessageSchema>;

export const createShareMessage = (text?: string) =>
  ({
    ...createMessage(),
    type: 'Share',
    content: {
      text,
    },
  }) satisfies ShareMessage;
